import { createSelector, createSelectorCreator, defaultMemoize } from 'reselect';
import { VasState } from '../../../store/store-type';
import { SearchResultModel } from './search-result.model';
import * as reducer from './text-control.reducer';

const searchResultListComparitor = (
    a: Array<SearchResultModel>,
    b: Array<SearchResultModel>
) => {
    const hashA = a.map(item => `${item.id}-${item.highlighted}`);
    const hashB = b.map(item => `${item.id}-${item.highlighted}`);
    return hashA === hashB;
};

const createSearchResultSelector = createSelectorCreator(
    defaultMemoize,
    searchResultListComparitor
);

const getState = (state: VasState): reducer.State => state.textControl;

const ins = (id: string) =>
    createSelector(
        getState,
        state => state.instances[id]
    );

const getControl = (id: string) =>
    createSelector(
        ins(id),
        state => state ? state.control : undefined
    );

export const getShowResults = (id: string) =>
    createSelector(
        ins(id),
        state => state ? state.showResults : false
    );

export const getSearchEnabled = (id: string) =>
    createSelector(
        getControl(id),
        control => control ? control.config.searchEnabled : false
    );

const getLookups = (id: string) =>
    createSelector(
        ins(id),
        state => state ? state.results : []
    );

export const getInputValue = (id: string) =>
    createSelector(
        ins(id),
        state => state ? state.inputValue || '' : ''
    );

const getSearchTerm = (id: string) =>
    createSelector(
        ins(id),
        state => state ? state.searchTerm || '' : ''
    );

const getShowAll = (id: string) =>
    createSelector(
        ins(id),
        state => state ? state.showAllResults : false
    );

const getMatches = (id: string) =>
    createSelector(
        getShowAll(id),
        getLookups(id),
        getSearchTerm(id),
        (showAll, lookups, searchTerm) => {

            if (showAll) {
                return lookups;
            }

            if (searchTerm.length === 0) {
                return [];
            }

            return lookups;
        }
    );

export const getResults = (id: string) =>
    createSearchResultSelector(
        getMatches(id),
        matches => matches
    );

export const getShowResultsWindow = (id: string) =>
    createSelector(
        getShowResults(id),
        getShowAll(id),
        getResults(id),
        (showResults, showAll, results) => {
            return (showResults || showAll) && results.length > 0;
        }
    );

export const getCanLoadMore = (id: string) =>
    createSelector(
        getState,
        state => {
            const instance = state.instances[id];
            const lookups = state.lookups[instance.lookupType] || [];
            const total = lookups.length;
            return (instance || {} as any).results.length < total;
        }
    );



// WEBPACK FOOTER //
// ./src/vas/controls/text/form/text-control.selectors.ts